import { useEffect, useState } from "react";
import CategoryLayout from "../layouts/CategoryLayout";
import "./../styles/category.css";
import { HashLoader } from "react-spinners";
import ToastNotification, { showToast } from "../components/toasts/ToastNotification";
import { getProductsByType } from "../api/product.api";
import { AccountCard } from "../components/dashboard/account-section";
import ScrollToTopButton from "../components/scroll-to-top/scroll-to-top-button";
import { UtilityCard } from "../components/dashboard/utility-section";

export const GiftCardCategory = () => {
    const [loading, setLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        fetchGameAccounts();
    }, []);

    const fetchGameAccounts = async () => {
        try {
            setLoading(true);
            const res = await getProductsByType("gift_card", 50);

            if (res.success) {
                const activeAccounts = res.data.products?.filter(
                    (acc) => acc.product_status === "active"
                );
                setAccounts(activeAccounts);
            }
        } catch (error) {
            showToast(error.message, "error");
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <CategoryLayout title={"Danh mục sản phẩm"}>
            <ToastNotification />
            <ScrollToTopButton />
            {loading ?
                <div style={{ height: "100vh" }} className="loader-container">
                    <HashLoader color="#0d79e2" />
                </div>
                :
                <div className="game-account-category-container">
                    <p>Hiển thị {accounts.length} sản phẩm</p>
                    <div className="account-info-container">
                        {accounts.length > 0 ?
                            accounts.map(acc => (
                                <UtilityCard key={acc._id} util={acc} />
                            ))
                            :
                            <p>Hiện tại chưa có sản phẩm</p>}
                    </div>
                </div>
            }
        </CategoryLayout>
    );
};
